<template>
	<!-- 订单待审核 -->
	<div class="ToAudit">
		<div class="cToAudit-top">
			<HeadCom :title="title"></HeadCom>
		</div>
		<div class="cToAudit">
			<el-row>
				<el-col :span="6" class="box">
						<span>标段(包)编号：</span>
						<el-input v-model="searchValue.sectionNo" placeholder="请输入内容"></el-input>
				</el-col>
				<el-col :span="6" class="box">
						<span>项目/标段(包)名称：</span>
						<el-input v-model="searchValue.sectionName" placeholder="请输入内容"></el-input>
				</el-col>
				<el-col v-if="userInfo.userType == 2 && routerFrom == 'CancelRefund'" :span="6" class="box">
						<span>订单状态：</span>
						<el-select class="selectClass" v-model="orderStatusSearch" clearable placeholder="请选择">
								<el-option v-for="item in orderStatusOptions" :key="item.value" :label="item.label" :value="item.value">
								</el-option>
						</el-select>                    
				</el-col>
				<!-- 待支付开标时间筛选 -->
				<el-col :span='12' v-if="routerFrom == 'GenerationPayment'">
					<span>开标时间：</span>
					<el-date-picker v-model="searchValue.bidOpeningStartDate" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
					 placeholder="选择开始日期" clearable>
					</el-date-picker>
					<i style="margin: 0 10px;">-</i>
					<el-date-picker v-model="searchValue.bidOpeningEndDate" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
					 placeholder="选择结束日期" placeholder-style='font-size:12px' clearable>
					</el-date-picker>
				</el-col>
				<el-col :span="6" v-if="userInfo.userType == 2 && userInfo.channel != '0000' && routerFrom == 'GenerationPayment'">
					<span>来源渠道：</span>
					<el-select class="selectClass" v-model="searchValue.channel" clearable filterable placeholder="请选择">
						<el-option v-for="(item,index) in channelList" :key="index" :label="item" :value="index">
						</el-option>
					</el-select>
				</el-col>			
				<el-col :span="6" class="box" v-if="userInfo.userType == 2">
					<span>被保证人：</span>
					<el-input class="beiBaoWidth" v-model="searchValue.warranteeName" placeholder="请输入内容"></el-input>
				</el-col>
				<el-col :span="6" class="box" v-if="userInfo.channel != '0000'">
							<span>订单编号：</span>
							<el-input v-model="searchValue.orderNo" placeholder="请输入内容"></el-input>
					</el-col>
				<el-col class="box" v-if="userInfo.userType == 2 && (routerFrom != 'GenerationPayment' || userInfo.channel == '0000') && routerFrom.indexOf('channel') ==-1 "
				  :span="6">
					<span>来源渠道：</span>
					<el-select class="selectClass" v-model="searchValue.channel" clearable filterable placeholder="请选择" style="width:100%;">
						<el-option v-for="(item,index) in channelList" :key="index" :label="item" :value="index">
						</el-option>
					</el-select>
				</el-col>
        <el-col class="box" :span="6">
					<span>交易中心编号：</span>
					<el-input v-model="searchValue.applicantLyYwlsh" placeholder="请输入内容"></el-input>
				</el-col>
				<el-col :span="6" class="box" v-if="userInfo.channel == '0000'">
							<span>订单编号：</span>
							<el-input v-model="searchValue.orderNo" placeholder="请输入内容"></el-input>
					</el-col>
				<el-col class="box" v-if="routerFrom == 'Haveletter'"
				  :span="6">
					<span>发票状态：</span>
					<el-select class="selectClass" v-model="searchValue.invoiceStatus" clearable placeholder="请选择" style="width:100%;">
						<el-option v-for="(label, value) in receiptStatusOptions" :key="value" :label="label" :value="value"></el-option>
					</el-select>
				</el-col>
				<template v-if="userInfo.userType == '4' && routerFrom == 'Haveletter'">
					<el-col :span="6" class="box">
						<span>保函编号：</span>
						<el-input v-model="searchValue.bhNo" placeholder="请输入内容"></el-input>
					</el-col>
					<el-col :span='12'>
						<span>出函时间：</span>
						<el-date-picker v-model="searchValue.issueStartDate" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
						placeholder="选择开始日期" clearable>
						</el-date-picker>
						<i style="margin: 0 10px;">-</i>
						<el-date-picker v-model="searchValue.issueEndDate" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
						placeholder="选择结束日期" placeholder-style='font-size:12px' clearable>
						</el-date-picker>
					</el-col>
				</template>
				<el-col class="search-btn" :span="showBtnType">
					<div class="btnClass">
						<el-button v-if="showExportBtn" type="primary" class="base-medium-btn" @click="handleexoprt">导出</el-button>
						<el-button type="primary" class="base-medium-btn" @click="searchBtn">查询</el-button>
						<el-button type="primary" class="base-medium-btn chongzhiBtn" @click="reset">重置</el-button>
					</div>
				</el-col>
      </el-row>
			<div class="innerBottom">
				<el-table ref='elTable' :data="tableData" stripe style="width: 100%" highlight-current-row>
					<el-table-column type="index" label="序号" width="60">
					</el-table-column>
					<el-table-column :prop="item.prop" :label="item.value" :width="item.width" v-for="(item, index) in tableDateDec"
					 :key="index" v-if="(item.prop != 'guaranteeType' && userInfo.userType != 2) 
					||userInfo.userType == 2 ">
						<template slot-scope="scope">
							<div v-if="item.prop == 'orderStatus'" style="font-size: 13px;">
								<span :title="scope.row['showStatus']">{{ scope.row["showStatus"] }}</span>
								<div :title="'支付确认截止时间'+scope.row['payLastTime'] ">
									<div v-if=" scope.row['payLastTime'] !='/' && (scope.row['orderStatus']==2 || scope.row['orderStatus']==14) "
									 style=" color: red;">支付确认截止时间</div>
									<div v-if="scope.row['payLastTime'] != '/' && (scope.row['orderStatus']==2 || scope.row['orderStatus']==14)"
									 style="color: red;">{{ scope.row["payLastTime"] }}</div>
								</div>
							</div>
							<!-- 渠道展示优先显示rateChannel字段，如果无则rateChannel -->
							<div :title="scope.row[item.prop]" v-else-if="item.prop == 'applicantChannel'">{{scope.row[item.prop]=='0000'?'国瑞':channelList[scope.row['rateChannel'] || scope.row[item.prop]]}}</div>
							<div v-else-if="item.prop == 'invoiceStatus'" :title="showInvoiceStatusTitle(scope.row)">{{showInvoiceStatusText(scope.row)}}</div>
							<div :title="scope.row[item.prop]" v-else>{{scope.row[item.prop]}}</div>
						</template>
					</el-table-column>
					<el-table-column fixed="right" width='115' prop="opreate" label="操作">
						<!--  用户类型为2 且是待付款  不为操作的时候 -->
						<!-- 或者不为 待付款页面 -->
						<!-- 用户类型是其他，但不是保函类型时 -->
						<template slot-scope="scope">
							<div class="tableBtn divClass" v-if="
											scope.row['orderStatus'] == 0 &&
												userInfo.userType == 2 &&
												(userInfo.sonFlag == 0 || userInfo.personnel == 1)
										"
							 @click="open(scope.$index, 'check')">审查</div>
							<!-- 投标人待出函之前都可删除订单 -->
							<div style="display: flex;" class="divClass">
								<span :class="['tableBtn', forbidPayFlag ? 'stop-click' : '']" v-if="
									((scope.row['orderStatus'] == 14 ||scope.row['orderStatus'] == 0)
									||scope.row['orderStatus'] == 2) && userInfo.userType == 4 "
								 @click="open(scope.$index, 'pay')">付款</span>
								<!-- 状态是待付款时，投标人可确认付款（查流水） -->
							</div>
							<div class="tableBtn divClass" v-if="
										(scope.row['orderStatus'] == 4 ||
											scope.row['orderStatus'] == 6) &&
											userInfo.userType == 2 
									"
							 @click="searchStatus(scope.row, scope.$index)">查询</div>

							<div style="display: flex; " class="divClass">
								<span class="tableBtn" @click="open(scope.$index, 'detail')">查看详情</span>
								<span class="tableBtn" style="margin-left: 5px;" v-if="
											(scope.row['orderStatus'] == 2 ||scope.row['orderStatus'] == 14||scope.row['orderStatus'] == 0) &&
												(userInfo.userType == 0 || userInfo.userType == 4) && scope.row['isDelete']
										"
								 @click="deleteOrder(scope.$index)">删除</span>
							</div>
                            <!-- 暂时移除联系方式 -->
							<!-- <div class="tableBtn divClass" v-if="
										(scope.row['orderStatus'] == 4 ||
											scope.row['orderStatus'] == 5) &&
											userInfo.userType == 4 
									"
							 @click="contactUs(scope.row, scope.$index)">
								<el-popover style='white-space: pre-line;' title='联系方式' placement="bottom" width='200' trigger='click' :content="contactList[targetBranchName]">
									<span slot="reference">联系方式</span>
								</el-popover>


							</div> -->
							<div v-if="
										scope.row['orderStatus'] == '7' &&
											userInfo.userType != '2' &&
											scope.row['uploadFlag'] == 1
									">
								<span class="tableBtn" @click="xz(scope.row, 'detail')">下载保函文件</span>
							</div>
							<div class="tableBtn divClass" v-if="
										(scope.row['orderStatus'] == 7 || scope.row['orderStatus'] == 11) &&
											scope.row['uploadFlag'] == 1 &&
											userInfo.userType != 2 &&
											scope.row['proOverdue'] == 1 && scope.row['isCanRevoke']
									"
							 @click="open(scope.$index, 'revoke')">{{scope.row['orderStatus'] == 11?'重新申请':'申请撤销退款' }}</div>

							<div class="divClass" v-if="
										(scope.row['orderStatus'] == '7' || scope.row['orderStatus'] == '11') &&
											userInfo.userType == '4' &&
											scope.row['uploadFlag'] == 1 &&
											scope.row['invoiceFlag'] == null
									">
								<span class="tableBtn" :style="scope.row['proOverdue'] ==1?'color:gray':'' " :title="scope.row['proOverdue'] ==1?'请在开标后再申请发票':'' "
								 @click="applyAcciept(scope.row)">申请发票</span>
							</div>
							<!-- 限制开票（待申请状态）/取消限制开票（已限制状态） -->
							<div class="divClass" v-if="showLimitInvoice(scope.row, '1')">
								<span class="tableBtn" @click="limitApplyReceipt(scope.row)">限制开票</span>
							</div>
							<div class="divClass" v-if="showLimitInvoice(scope.row, '2')">
								<span class="tableBtn" @click="cancelLimitApplyReceipt(scope.row)">取消限制开票</span>
							</div>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="pagePart">
				<el-pagination style="text-align: right;" background layout="prev, pager, next,total" :page-size="size" :total="totleListCount"
				 @current-change="handleCurrentChange" :current-page="page">
				</el-pagination>
			</div>
		</div>
		<!-- 、撤销退款 -->
		<!-- <revokeOrder v-show="showRevokeOrder" @cancelShow="cancelShow"></revokeOrder> -->
		<revokeOrder v-if="showRevokeOrder" :showRevokeOrder="showRevokeOrder" :orderDetail.sync="orderSingleDetail"
		 @successShow="successShow" @cancelShow="cancelShow"></revokeOrder>
		<!-- 付款 -->
		<payAndSearchFlow :show.sync='showPayment' v-if="showPayment" :payData="payData" @payClose='payClose' @submitCallback='payCallback'></payAndSearchFlow>
		<applyInvoiceList v-if="showApplyInvoice" :show.sync="showApplyInvoice" :orderDetail.sync="orderSingleDetail"></applyInvoiceList>

		<choseGuarantee @successBack='successBack' v-if="showchooseGuarantee" :show.sync="showchooseGuarantee"
		 :orderDetail.sync="orderSingleDetail"></choseGuarantee>

		<exportDate v-if='showExportMask' :searchData='exportParam' :show.sync='showExportMask' :type='3'></exportDate>
	</div>
</template>
<script>
	import {
		mapState,
		mapMutations
	} from "vuex";
	import elSelectCityChose from "@/components/elSelectCityChose/elSelectCityChose.vue";
	import HeadCom from "../../headCom";
	import payAndSearchFlow from "@/components/payAndSearchFlow.vue";
	import applyInvoiceList from "@/components/applyInvoiceList/applyInvoiceList.vue";
	import revokeOrder from "../revokeOrder/index";
	import choseGuarantee from "@/components/choseGuarantee.vue";
	import exportDate from "@/components/exportDate.vue";

	import { setStorage, getStorage } from "@/utils/localhost";
	export default {
		components: {
			payAndSearchFlow,
			applyInvoiceList,
			elSelectCityChose,
			HeadCom,
			revokeOrder,
			choseGuarantee,
			exportDate
		},
		props: {
			routerFrom: {
				type: String,
				default: null,
			},
		},
		data() {
			return {
				channelList: [],
				dialogContract: false, //联系方式
				contactList: {},
				targetBranchName: '',
				clickFlag: false, //点击分页时判断是否携带查询数据
				showchooseGuarantee: false,
				showApplyInvoice: false,
				showRevokeOrder: false,
				orderSingleDetail: {},
				showSurePayment: false,
				showPayment: false,
				title: "待审核",
				orderStatus: 0,//该字段仅限于用于标识当前页面的模块
				input: "",
				searchValue: {
					bhType: '',
					sectionNo: "",
					sectionName: "",
					warranteeName: "",
					orderNo: '',
					applicantType: '',
					uploadFlag: '',
					applicantLyYwlsh: '',
					// 投标截止时间搜索 默认从当时刻为起始时间，查为开标的订单
					bidOpeningStartDate: '',
					bidOpeningEndDate: '',
					invoiceStatus: '',
					bhNo: '',
					issueStartDate: '',
					issueEndDate: '',
				},
				orderStatusSearch:"-1",//(为了不改之前代码，此处单独申明字段)撤销退款时加订单审批状态查询("-1"：全部，"9"：退款审核中, "10":退款通过, "11":退款被驳回,查询前处理)
				orderStatusOptions:[
					{value:"-1",label:"全部"},
					{value:"9",label:"退款审核中"},
					{value:"10",label:"退款通过"},
					{value:"11",label:"退款被驳回"},
				],
				currentPage: 1, //当前页
				totleListCount: 1, //总共数量
				tableDateDec: [{
						prop: "orderNo",
						value: "订单编号",
						width: "130",
					}, {
						prop: "applicantLyYwlsh",
						value: "交易中心编号",
						width: "110",
					}, {
						prop: "sectionNo",
						value: "标段(包)编号",
						showTip: true,
						width: "",
					},
					{
						prop: "sectionName",
						value: "标段(包)名称",
						showTip: true,
						width: "",
					},
					{
						prop: "submitDocumentsDeadline",
						value: "投标文件递交截止日期",
						width: "110",
					},
					{
						prop: "amountGuaranteed",
						value: "保证金金额(万元)",
						width: "110",
					},
					{
						prop: "guaranteePrice",
						value: "价格(元)",
						width: "80",
					},
					{
						prop: "guaranteeBusinessShow",
						value: "保函类型",
						width: "80",
					},

					{
						prop: "orderStatus",
						value: "订单状态",
						width: "100",
					}, {
						prop: "issueTime",
						value: "出函时间",
						width: "110",
					},
				],
				// 表格数据
				tableData: [],
				BohanMode: [{
						label: "电子保函",
						value: 1,
					},
					{
						label: "纸质保函",
						value: 0,
					},
				],
				page: 1,
				size: 10,
				roleListValue: 3, //渠道企业订单，投标人企业订单
				payData: {},
				fileShow: "", //下载文件
				tenderDocumentfileType: "",
				forbidPayFlag: false, // 禁止付款（按钮置灰）
				receiptStatusOptions: {
					'0': '待审核',
					'1': '已开票',
					'2': '已撤销',
					'3': '开票中',
					'4': '开票失败',
					'5': '已登记',
					'6': '未申请',
					'7': '已限制',
					'9': '驳回',
				},
				showExportMask: false,
				exportParam: {},
			};
		},
		computed: {
            ...mapState(["enterpriseCert","channelDec"]),
            // 控制按钮根据不同渠道不同用户展示(按钮区)不同的栅格布局份数
            showBtnType(){
                let routerFrom = this.routerFrom;
                let channel = this.userInfo.channel;
                let userType = this.userInfo.userType;
                // 0000代表国瑞登陆
                if(channel == '0000'){
                    // 2为担保机构
                    if(userType == '2'){
                        // 渠道订单一律24份
                        if(routerFrom.indexOf('channel')!=-1){
                            return 18;
                        }else if(routerFrom=='GenerationPayment'){
                            return 24;
                        }else if(routerFrom=='CancelRefund'){
                            return 6;
                        }else if(routerFrom == 'Haveletter'){
                            return 6;
                        }else{
                            return 12;
                        }
                    }else{
                        if(routerFrom=='GenerationPayment'){
                            return 12;
                        }else if(['CancelRefund', 'GenerationLetter', 'deleted', 'Haveletter'].includes(routerFrom)){
                            return 24;
                        }else{
                            return 24;
                        }
                    }
                }else{
                    if(userType == '2'){
                        if(routerFrom=='CancelRefund'){
                            return 6;
                        }else if(routerFrom=='GenerationLetter' || routerFrom=='deleted'){
                            return 12;
                        }else if(routerFrom == 'Haveletter'){
                            return 6;
                        }else{
                            return 24;
                        }
                    }else{
                        if(routerFrom=='GenerationPayment'){
                            return 12;
                        }else if(routerFrom == 'Haveletter'){
                            return 24;
                        }else{
                            return 24;
                        }
                    }
                }
						},
						// 担保机构+已出函
						showExportBtn(){
							return this.userInfo.userType === '2' && this.routerFrom === 'Haveletter';
						}
		},
		watch: {
			area(obj1, obj2) {
				this.page = 1;
				this.tableData = [];
				this.requestData();
			},
			orderDetail(obj1, obj2) {},
			$route(to, from) {
                // return;
                // console.log("to的：",to, "from的：",from)
				// 菜单切换需更新数据，但是从详情内部返回，不需要更新数据
				if ((to.path.split('/')[2] == 'orderManagement' || to.path.split('/')[2] == 'channalOrder') && from.path.split('/')[
						3] != 'orderDetail' && to.path.split('/')[3] != 'orderDetail') {
					this.page = 1;
                    this.tableData = [];
                    // 由于临海外部登陆跳转进来时手动去除router的query的orderNo，也会触发监听，但无需刷新页面
                    if(to.path != from.path){
                        this.requestData();
                    }
				}
			},
		},
		created() {
			// 通过页面，调用组件传的参数不同，区分当前页面状态
			if (this.routerFrom.indexOf("GenerationLetter") != -1) {
				this.title = "待出函";
				this.orderStatus = 4;
			} else if (this.routerFrom.indexOf("GenerationPayment") != -1) {
				this.title = "待付款";
        this.orderStatus = 2;
        // 获取是否禁止付款标识(此处单独调接口实时获取)
				this.getPayStatus();
				this.tableDateDec.forEach((item, index) => {
					if (item.prop == 'orderStatus') {
						item.width = '170'
						this.$set(this.tableDateDec, index, item)
						return
					}
				})
				this.$set(this.searchValue, 'bidOpeningStartDate', this.publicMethed.formatDateTime(new Date()))
                // 临海外部链接带订单跳转进来时(从稠银登陆页面跳来)
                console.log(this.$route.query.orderNo)
                if(this.$route.query.orderNo != undefined){
                    this.searchValue.orderNo = this.$route.query.orderNo;
                    // 移除router的query中的orderNO参数
                    let newQuery = JSON.parse(JSON.stringify(this.$route.query));
                    delete newQuery.orderNo;
                    this.$router.replace({query:newQuery});
                }
			} else if (this.routerFrom.indexOf("CancelRefund") != -1) {
				this.title = "撤销退款";
				this.orderStatus = 9;
			} else if (this.routerFrom.indexOf("Haveletter") != -1) {
				this.title = "已出函";
				this.orderStatus = 7;
				// 临海外部链接带订单跳转进来时(从稠银登陆页面跳来)
				console.log(this.$route.query.orderNo)
				if(this.$route.query.orderNo != undefined){
				  this.searchValue.orderNo = this.$route.query.orderNo;
				  // 移除router的query中的orderNO参数
				  let newQuery = JSON.parse(JSON.stringify(this.$route.query));
				  delete newQuery.orderNo;
				  this.$router.replace({query:newQuery});
				}
				this.tableDateDec.splice(1, 0, {
					prop: "bhNo",
					value: "保函编号",
					width: "120",
				});
			} else if (this.routerFrom.indexOf("deleted") != -1) {
				this.title = "已删除";
				this.orderStatus = 12;
			} else if (this.routerFrom.indexOf("fail") != -1) {
				this.title = "岀函失败";
				this.orderStatus = 5;
			}

			for (let i = 0; i < this.tableDateDec.length; i++) {
				let tem = this.tableDateDec[i]
				if (tem.prop == 'issueTime') {
					if (this.orderStatus < 7 && this.orderStatus != 14 || this.orderStatus == 12) {
						this.tableDateDec.splice(i, 1)
					}
				}
        if (this.userInfo.channel == '0000') {
					// if (tem.prop == 'applicantLyYwlsh') {
					// 	this.tableDateDec.splice(i, 1)

					// }
				} else {
					if (tem.prop == 'guaranteeBusinessShow') {
						this.tableDateDec.splice(i, 1)

					}
				}
			}
			if (this.userInfo.userType == 2) {
				this.tableDateDec.unshift({
					prop: "warranteeName",
					value: "投标人",
					width: "120",
        })
        // 如果是担保机构追加表格来源渠道的字段(渠道订单模块不添加)
        this.routerFrom.indexOf('channel') ==-1 && this.tableDateDec.push({
            prop:"applicantChannel",
            value:"来源渠道",
            width:"80"
        })
      }
			// 已出函时追加“发票状态”
			if(this.routerFrom === 'Haveletter'){
				this.tableDateDec.push({
            prop:"invoiceStatus",
            value:"发票状态",
            width:"110"
        })
      }
      this.searchFormData = this.searchValue
		},
		mounted() {
            this.channelList = this.publicMethed.ownAreasChannel()
			if (this.userInfo.userType == 2) {
				this.BohanMode.unshift({
					label: "不限",
					value: '',
				});
			}
			this.targetIndex = -1;
			if (this.thirdDate.hasOwnProperty('searchType') && this.thirdDate.searchType == 'orderList') {
				for (let key in this.thirdDate.searchValue) {
					if (key != 'type') {
						this.$set(this.searchValue, 'applicantLyYwlsh', this.thirdDate.searchValue[key])
					}
				}
				// 查询后清除
				this.$store.commit('onChangeThirdDate', {})
			}
			if (typeof this.$route.params != 'undefined' && typeof this.$route.params.orderNo != 'undefined') {
				this.$set(this.searchValue, 'orderNo', this.$route.params.orderNo)
			}
			this.requestData();
			// this.open(0,'pay')
		},
		activated() {},
		methods: {
			// 处理发票状态显示
			showInvoiceStatusText(row){
				const { invoiceStatus, invoiceFlag } = row;
				return invoiceFlag == '2' ? '已限制' : this.receiptStatusOptions[invoiceStatus];
			},
			// 处理发票状态悬浮显示
			showInvoiceStatusTitle(row){
				const { invoiceStatus, invoiceFlag, invoiceRemark } = row;
				return invoiceFlag == '2' ? invoiceRemark : this.receiptStatusOptions[invoiceStatus];
			},
			// 显示限制/取消限制开票按钮:flag为1是限制为2是取消限制按钮
			showLimitInvoice(row, flag){
				const { orderStatus, invoiceStatus, invoiceFlag } = row;
				if(this.userInfo.userType != '2') return false;
				if(orderStatus != '7') return false;
				if(flag == '2'){
					return invoiceFlag == '2';
				} else {
					return invoiceFlag != '2' && ['2', '4', '6', '9'].includes(invoiceStatus);
				}
			},
			// 检验最大字节长度
			handleStrLenValid(value, maxCharCodelen){
				const len = value.length;
				let currentLen = 0;
				let isOk = true;
				for (let i = 0; i < len; i++) {
					if (value[i].charCodeAt() <= 255) {
						currentLen++;
					} else {
						currentLen += 2;
					}
					if (currentLen > maxCharCodelen) {
						isOk = false;
						break;
					}
				}
				return isOk;
			},
			// 限制开票（只有invoiceStatus为2469可以限制开票，注意限制成功后不改该字段值，是更改invoiceFlag为2:限制开票）
			limitApplyReceipt(row){
				this.$prompt('限制申请', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					closeOnClickModal: false,
					inputPlaceholder: '请输入限制开票原因',
					inputValidator: (value) => {
						if(!value) return '限制原因不能为空';
						let flag = this.handleStrLenValid(value, 30);
						if(!flag) return '限制30个字符';
					},
					inputErrorMessage: '限制30个字符',
					beforeClose: (action, instance, done) => {
						// console.log('action', action);
						if(action == 'cancel') return done();
						const obj = {
							remark: instance.inputValue,
							orderNo: row.orderNo,
							status: '1'
						}
						this.requestAPI['restrictOrderApply'](obj).then(res=>{
							if (res.errorCode == '0000'){
								this.$set(row, 'invoiceRemark', obj.remark);
								this.$set(row, 'invoiceFlag', '2');
								this.$message.success(res.errorMsg);
								done();
							}
						})
					}
				})
			},
			// 取消限制开票（不用管invoiceStatus字段值，只考虑invoiceFlag为2时可以取消限制开票）
			cancelLimitApplyReceipt(row){
				this.$confirm('是否确定取消限制开票？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					closeOnClickModal: false,
					type: 'warning'
				}).then(valid => {
					let obj = { orderNo: row.orderNo, status: '0' };
					this.requestAPI['restrictOrderApply'](obj).then(res=>{
						if (res.errorCode == '0000') {
							this.$message.success(res.errorMsg);
							this.$set(row, 'invoiceRemark', '');
							this.$set(row, 'invoiceFlag', null);
						}
					})
				})
			},
			// 导出(暂时只有已出函有，orderStatus为7)
			handleexoprt(){
				this.showExportMask = true;
				this.handleExportParam();
			},
			// 处理导出的参数
			handleExportParam(){
				let obj = { ...this.searchFormData };
				obj['orderStatus'] = [7];
				obj["applicantType"] = 0;
				obj["enterpriseId"] = this.userInfo.enterpriseId;
				obj["existType"] = 1;
				obj['selectType'] = 3;
				obj["userType"] = this.userInfo.userType;
				this.exportParam = obj;
				console.log('obj:', obj)
			},
			// 获取最新付款状态
			getPayStatus(){
				const enterpriseId = this.userInfo.enterpriseId
				this.requestAPI.checkBeneficiaryAndKggdFull({ enterpriseId }).then(res=>{
					if(res.data && res.data.allowFlag){
						this.forbidPayFlag = res.data.allowFlag === '0';
					}
				})
			},
			// 处理用户中心带条件跳转来
			handleJump(){
				// 撤销退款时
				if(this.$route.path === '/internalSystem/orderManagement/cancelRefund'){
					if(this.$route.query.orderStatus != undefined){
						this.orderStatusSearch = this.$route.query.orderStatus;
						// 移除router的query中的orderStatus参数
						let newQuery = JSON.parse(JSON.stringify(this.$route.query));
						delete newQuery.orderStatus;
						this.$router.replace({query:newQuery});
					}
				}
			},
			// 申请发票
			applyAcciept(Obj) {
				if (Obj['proOverdue'] == 1) {
					return
				}
				if (Obj.invoiceFlag == 1) {
					return
				}
				this.orderSingleDetail = Obj;
				this.showApplyInvoice = true;
			},
			//下载
			xz(item) {
				if (item.bhFileUrl == null || item.bhFileUrl == '') {
					this.$confirm("未查询到当前订单保函文件", "提示", {
						confirmButtonText: "确认",
						showCancelButton: false,
						closeOnClickModal: false,
						showClose: false,
						type: "warning",
					}).then(() => {})
					return
				}
				// 缓存过即可不在下载
				if (typeof item.fileShow != 'undefined') {
					this.publicMethed.saveFileToLocal(item.fileShow, item.fileShowName);
				} else {
					let data = {
						fileUrl: item.bhFileUrl,
					};
					// 区别ofd和pdf  2:odf   1：pdf
					if (item.fileType == '2') {
						data.fileUrl = data.fileUrl + '_application/octet-stream'
					}
					this.publicMethed.downLoadImageC(data, (res, type) => {
						item['fileShow'] = res
						let name = item.sectionName + '保函文件'
						if (item.fileType == '2') {
							name = name + '.ofd'
						} else {
							name = name + '.pdf'
						}
						item['fileShowName'] = name
						this.publicMethed.saveFileToLocal(res, name);
					}, null);
				}
			},
			// 仅限出函失败且保函编号为null的（密文函还原保函可能失败,不算）
			resetOrder(index) {
				let data = {
					orderNo: this.tableData[index].orderNo
				}
				this.requestAPI.resetOrder(data).then((res) => {
					// this.$message({
					// 	message: '',
					// 	type: 'success'
					// });
					// this.tableData.splice(index, 1)
					this.$router.push({
						name: 'generationPayment',
						params: {
							orderNo: this.tableData[index].orderNo
						}
					})
				});
			},
			// 切换页
			handleCurrentChange(value) {
				this.page = value;
				if (this.clickFlag) {
					this.requestData("search");
				} else {
					this.requestData();
				}
				// }
			},
			// 查询
			searchBtn() {
				// if (this.routerFrom == 'GenerationPayment') {
				// 	if (
				// 		new Date(this.searchValue.bidOpeningStartDate).getTime() >
				// 		new Date(this.searchValue.bidOpeningEndDate).getTime()
				// 	) {
				// 		this.$message.error("搜索条件开标起始时间不能大于开标结束时间")
				// 		return
				// 	}
				// }

				this.page = 1;
				this.tableData = [];
		                this.clickFlag = true;
				for (let key in this.searchValue) {
					this.$set(this.searchFormData, key, this.searchValue[key]);
				}
				this.requestData();
			},
			// 重置
			reset() {

				for (let key in this.searchValue) {
					if (this.routerFrom == 'GenerationPayment' && key == 'bidOpeningStartDate') {
						this.$set(this.searchValue, key, this.publicMethed.formatDateTime(new Date()));
						this.$set(this.searchFormData, key, this.publicMethed.formatDateTime(new Date()));
						continue
					}
					this.$set(this.searchValue, key, "");
					this.$set(this.searchFormData, key, "");
				}
				// this.$set(this.searchValue, "bhType", -1);
				this.page = 1;
                this.tableData = [];
                this.orderStatusSearch = "-1";
				this.clickFlag = false;
				this.requestData();
			},
			// 请求数据
			requestData(str) {
				this.handleJump();
				let data = {
					page: this.page,
					size: this.size,
					// bhType:-1,
				};
				data = Object.assign(data, this.searchFormData)
				if (this.userInfo.userType == 2) {
					if (this.routerFrom.indexOf("channel") != -1) {
						data["applicantType"] = 1;
					} else {
						data["applicantType"] = 0;
					}
				}

				data["userType"] = this.userInfo.userType;
				data["existType"] = 1
				// selectType  排序条件
				switch (this.orderStatus) {
					case 7:
						data['selectType'] = 3
						data['orderStatus'] = [7]
						if (this.userInfo.userType != 2) { //担保机构
							data['uploadFlag'] = 1 //除担保机构外，已上传标志需为1
						}
						break;
					case 4:
						data['selectType'] = 2
						data['orderStatus'] = [4, 6, 8]
						if (this.userInfo.userType != 2) {
							data['orderStatus'].push(7)
							data['uploadFlag'] = 0 //除担保机构外，orderStatus为7，uploadFlag为0，也是带出函
						}
						break;
					case 2:
						data['selectType'] = 1
						data['orderStatus'] = [0, 1, 2, 14]
						break;
					case 9:
						data['selectType'] = 4
                        // 撤销退款模块：担保机构订单状态根据查询条件设定，其余登陆的默认[9,10,11]
                        data['orderStatus'] = this.orderStatusSearch==9 ? [9] : this.orderStatusSearch==10 ? [10] : this.orderStatusSearch==11 ? [11] : [9, 10, 11];
						break;
					case 12:
						data['selectType'] = 5
						data['orderStatus'] = [2, 14]
						data["existType"] = 2
						break;
					case 5:
						data['orderStatus'] = [5];
						data['selectType'] = 4;
						break;
				}
				data["enterpriseId"] = this.userInfo.enterpriseId;
				this.requestAPI.orderFind(data).then((res) => {
					let result = res;
					this.totleListCount = result.data.totalCount;
					//
          this.tableData = result.data.orderList;
					this.handleTable(this.tableData);


				});

			},
			// 处理table数据
			handleTable(data) {
				// 不可撤销退款的渠道
        let notRevoke = ['0012', '0017', '0019', '0021', '0022','0024','0025','0007', '0029','0001','0030','0031','0032','0033', '0039', '0005', '0035', '0040', '0041', '0037', '0044', '0045', '0036', '0046', '0047', '0049', '0050'];
        // 不可删除订单的渠道
        let notDelete = ['0007', '0023', '0026', '0029','0001','0032', '0033', '0039', '0005', '0035', '0040', '0044', '0045', '0046', '0047', '0049', '0050'];
				for (let i = 0; i < data.length; i++) {
					if (this.orderStatus == 12) {
						data[i].orderStatus = 12
					}
					if (data[i].orderStatus == 7) {
						if (data[i].uploadFlag == null) {
							data[i].uploadFlag = 0;
						}
						if (this.userInfo.userType == 2) {
							if (data[i].uploadFlag == 0) {
								data[i]["showStatus"] = "待上传";
							} else {
								data[i]["showStatus"] = "已出函";
							}
						} else {
							if (this.orderStatus == 4) {
								data[i]["showStatus"] = "待出函";
							} else {
								data[i]["showStatus"] = "已出函";
							}
						}
					} else {
						data[i]["showStatus"] = this.publicMethed.orderStatusList[data[i].orderStatus];
					}
					// 密文 截止时间为 /   需显示退款等按钮
					let data1 = new Date(data[i].submitDocumentsDeadline.replace(/-/g, "/")).getTime();
					if (data[i].submitDocumentsDeadline == '/' || data1 >= new Date().getTime()) {
						data[i]["proOverdue"] = 1; //1:未开标 项目已开标不显示申请撤销退款
					} else {
						data[i]["proOverdue"] = 0;
					}
					// 该渠道是否支持撤销退款
                    data[i]['isCanRevoke'] = notRevoke.indexOf(data[i].applicantChannel) != -1?0:1
                    // 该渠道是否支持删除订单
                    data[i]["isDelete"] = notDelete.indexOf(data[i].applicantChannel) != -1 ? false : true;
					if (data[i].infoEncodeType == 0) {
						// data[i].beneficiaryName = "***";
						// data[i].beneficiaryCreditCode = "***";
						// data[i].sectionName = "***";
						// data[i].sectionNo = "***";
						// data[i].projectName = "***";
						// data[i].projectNo = "***";
						// data[i].submitDocumentsDeadline = "***";
					}
					data[i].orderStatus = Number(data[i].orderStatus);
					data[i]["guaranteeBusinessShow"] = this.publicMethed.banhanMode[Number(data[i].guaranteeBusiness)];


				}
				this.$nextTick(() => {
					if (this.$refs.elTable) {
						this.$refs.elTable.doLayout()
					}

				})
			},
			provinceChange(value) {
				this.areas.province = value;
			},
			cityChange(value) {
				this.areas.city = value;
			},
			countryChange(value) {
				this.areas.country = value;
			},
			formData(data) {
				return (
					data.getFullYear() + "" + (data.getMonth() + 1) + "" + data.getDate()
				);
			},

			contactUs(row, index) {
				this.targetBranchName = row.branchName
				if (this.contactList.hasOwnProperty(row.branchName)) {
					this.dialogContract = true
				} else {
					this.requestAPI.selGuaranteeContactInfo({
						guaranteeId: row.guaranteeId,
					}).then((res) => {
						this.dialogContract = true
						let result = res.data.split('|&|')
						let str = ''
						for (let i = 0; i < result.length; i++) {
							str = str + result[i] + '\n'
						}
						this.$set(this.contactList, row.branchName, str)
					})
				}

			},
			// 纸质保函/电子保函查询订单状态(通知错误的情况担保公司可手动查询)
			searchStatus(Obj, index) {
				let data = {
					orderNo: Obj.orderNo,
					guaranteeId: Obj.guaranteeId,
				};
				new Promise((resolve, reject) => {
					this.requestAPI.bhSystem(data).then((res) => {
						resolve(res.data);
					});
				}).then((res) => {
					Obj.orderStatus = res.orderStatus;
					let status = this.publicMethed.orderStatusList[res.orderStatus]
					this.$confirm("您当前订单状态为：" + status, "查询成功", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					}).then(() => {
						if (res.orderStatus == 7 || res.orderStatus == 9) {
							this.tableData.forEach((item, index) => {
								if (item.orderNo == Obj.orderNo) {
									this.tableData.splice(index, 1);
								}
							});
						}
					});
				});
			},
			deleteOrder(index) {
				this.$confirm("此操作将删除该订单数据，是否继续执行删除操作？", "提示", {
					confirmButtonText: "删除",
					cancelButtonText: "取消",
					type: "warning",
				}).then(() => {
					let data = {
						applicantId: this.userInfo.enterpriseId,
						userId: this.userInfo.userId,
						orderNoArray: [this.tableData[index].orderNo]
					}
					this.requestAPI.deleteOrder(data).then((res) => {
						if (res.errorCode == '0000') {
							this.tableData.splice(index, 1)
							this.$message({
								type: "success",
								message: "删除成功!",
							});
						}
					})
				});
			},
			// 审查
			async open(index, str, tipFlag) {
				this.targetIndex = index;
				if (str == "detail" || str == "check") {
					this.$router.push({
						path: "/internalSystem/orderManagement/orderDetail",
						query: {
							orderNo: this.tableData[this.targetIndex].orderNo,
							existType: this.orderStatus == 12 ? 2 : 1,
              applicantChannel:this.tableData[this.targetIndex].applicantChannel,
              routerFrom: this.routerFrom
						},
					});
				} else if (str == "pay") {
          if(this.forbidPayFlag) return;
                    // 付款前判断该订单对应的渠道是否已经停用
                    const channelInfo = this.channelDec[this.tableData[index].applicantChannel];
                    // console.log(channelInfo)
                    if(channelInfo && channelInfo.isStart !== "1"){
                        this.$confirm(channelInfo.remark,"提示",{
                            showCancelButton:false,
							confirmButtonText: '确定',
                            type: 'warning',
                            closeOnClickModal:false,
                            closeOnPressEscape:false
                        })
                        return;
                    }
           // 密文函申请时,加提示
              const currentData = this.tableData[this.targetIndex];
              if(currentData.infoEncodeType == 0 && !tipFlag){
                  let result = "";
                  try {
                      result = await this.$confirm(`请确认申请编号(${currentData.applicantLyYwlsh})是否与您需购买的项目在交易中心系统中的编号一致。`, '提示', {
                      confirmButtonText: '确定一致',
                      cancelButtonText: '取消',
                      type: 'warning',
                      customClass: 'custom-confirm',
                    })
                  } catch (error) {
                    result = error; 
                  }
                  if(result != 'confirm'){
                    return;
                  }
              }
					// 付款前需保证已关联担保机构
					// if (typeof this.tableData[index].payLastTime != 'undefined' && this.tableData[index].payLastTime != null && this.tableData[
					// 		index].payLastTime != '/') {
					// 	let tem1 = new Date(
					// 		this.tableData[index].payLastTime.replace(/-/g, "/")
					// 	);
					// 	if (tem1.getTime() < new Date().getTime()) {
					// 		this.$alert(
					// 			"该订单已超过支付截止时间,截止时间为:" +
					// 			this.tableData[index].payLastTime,
					// 			"提示", {
					// 				confirmButtonText: "确定",
					// 				type: "warning",
					// 				callback: (action) => {},
					// 			}
					// 		);
					// 		return;
					// 	}
					// }
					if (this.tableData[index].applicantChannel != '0000' ||
						(this.tableData[index].bankNo == '' || this.tableData[index].bankNo == null || this.tableData[index].bankNo ==
							'/')) {
						if (this.tableData[index].orderStatus == 14) {
							this.showchooseGuarantee = true
							this.orderSingleDetail = this.tableData[index]
							return
						}
						if (this.tableData[index].orderStatus == 0) {
							this.$alert(
								"该订单审核中，请稍后",
								"提示", {
									confirmButtonText: "确定",
									type: "warning",
									callback: (action) => {},
								}
							);
							return;
						}
					}
					// 校验关联状态，新点校验基本户
					this.checkIsCanPay(index, (bools) => {
						if (bools) {
							this.payData = {}
							let temDate = this.tableData[this.targetIndex]
							this.$set(this.payData, 'payLastTime', temDate.payLastTime)
							this.$set(this.payData, 'orderNo', temDate.orderNo)
							this.$set(this.payData, 'applicantChannel', temDate.applicantChannel)
							this.$set(this.payData, 'money', temDate.totalFee)
							this.$set(this.payData, 'applicantLyYwlsh', temDate.applicantLyYwlsh)
							this.$set(this.payData, 'infoEncodeType', temDate.infoEncodeType)
							let addrNo = temDate.addrNo.split("_")[0]
							// 福建地区显示招标编号，其他区域不需要显示20210623
							if (temDate.infoEncodeType == 1 && addrNo == '350000') {
								this.$set(this.payData, 'projectNo', temDate.projectNo)
							}
							let temTime = new Date(new Date(temDate.createTime).getTime() - 30 * 24 * 60 * 60 * 1000)
							let ydm = this.publicMethed.formatDateTime(temTime).split(" ")[0]
							this.$set(
								this.payData,
								"startTradeTime",
								ydm.replace(/-/g, '')
							);

							this.showPayment = true;
						}
					})
				} else if (str == "edit") {} else if (str == "revoke") {
					// 点击遮罩或者取消
					this.showRevokeOrder = true;
					this.orderSingleDetail = this.tableData[index];
				}
			},
			checkIsCanPay(index, successBack, failBack) {
				// 校验  先看关联状态，再校验数据
				let data = {
					acId: this.tableData[index].acId,
					bidderId: this.userInfo.enterpriseId,
					guaranteeId: this.tableData[index].guaranteeId,
				};

				this.requestAPI.contractAgree(data).then((res) => {
					let result = res;
					let tem = res.data;
					if (tem.signFlag == 0) {
						this.$message.error("等待金融机构审核中,请您稍后再操作！");
					} else if (tem.signFlag == 2 || tem.signFlag == 4 || tem.signFlag == 5) {
						let str = tem.signFlag == 4 ? "的关联信息已失效" : (tem.signFlag == 2 ? '的关联申请被驳回' : '签署的协议有新版本')

						this.$confirm("您与出函机构 " + this.tableData[index].branchName + " (" + this.tableData[index].guaranteeName +
								')' + str + ", 是否去重新提交?", "提示", {
									confirmButtonText: "确定",
									cancelButtonText: "取消",
									type: "warning",
								})
							.then(() => {
								this.$router.push({
									path: '/internalSystem/Financial',
									name: 'Financial',
									params: {
										branchName: this.tableData[index].branchName,
                                        enterpriseName: this.tableData[index].guaranteeName,
                                        orderNo:this.tableData[index].orderNo,//用于签署后返回订单页面
									}
								});
							})
							.catch(() => {});
					} else if (tem.signFlag == 3) {
						this.$confirm(
								"您未与该出函机构 " + this.tableData[index].branchName + "(" + this.tableData[index].guaranteeName +
								")签署反担保委托协议, 是否去签署?",
								"提示", {
									confirmButtonText: "确定",
									cancelButtonText: "取消",
									type: "warning",
								}
							)
							.then(() => {
								this.$router.push({
									path: '/internalSystem/Financial',
									name: 'Financial',
									params: {
										branchName: this.tableData[index].branchName,
                                        enterpriseName: this.tableData[index].guaranteeName,
                                        orderNo:this.tableData[index].orderNo,//用于签署后返回订单页面
									}
								});
							})
							.catch(() => {});
					} else {
						new Promise((resolve, reject) => {
							// 保函类型是电子保函
							if (this.tableData[index].guaranteeBusiness == "1") {
								let data = {
									orderNo: this.tableData[index].orderNo,
								};
								this.requestAPI.checkXinDianBasicAccount(data).then((res) => {
									if (res.data.status == 1) {
										let list = ['0014', '0009'] //鹿城，德清渠道
										
										if (this.tableData[index].sectionNoAlias == null && list.includes(this.tableData[index].applicantChannel)) {
											let _sectionNo1 = ''
											let _sectionNo2 = ''
											const h = this.$createElement;
												if (document.getElementById("sectionNoInput1")) {
													document.getElementById("sectionNoInput1").value = ''
												}
												if (document.getElementById("sectionNoInput2")) {
													document.getElementById("sectionNoInput2").value = ''
												}
											this.$msgbox({
												title: '请输入项目标段编号',
												message: h('div', {}, [
													h('div',{
														style:'display:flex;align-items:center'
													},[
														h('span', {
															style:'width:110px;text-align:right;padding-right:5px'
															},'请输入:'),
														h('textarea', {
															attrs: {
																class: 'el-textarea__inner',
																autocomplete: 'off',
																rows: 2,
																placeholder: '请从交易中取得正确的标段编号填写在此处',
																id: 'sectionNoInput1',
																maxLength: 30
															},
															value: _sectionNo1,
															on: {
																input: () => {
																	_sectionNo1 = document.getElementById("sectionNoInput1").value
																}
															}
														}),
													]),
													h('div',{
														style:'display:flex;align-items:center'
													},[
														h('span', {
															style:'width:110px;text-align:right;padding-right:5px'
															},'请再次输入:'),
														h('textarea', {
															attrs: {
																style: 'margin-top:10px',
																class: 'el-textarea__inner',
																autocomplete: 'off',
																rows: 2,
																placeholder: '请从交易中取得正确的标段编号填写在此处',
																id: 'sectionNoInput2',
																maxLength: 30
															},
															value: _sectionNo2,
															on: {
																input: () => {
																	_sectionNo2 = document.getElementById("sectionNoInput2").value
																}
															}
														})
													])
												]),
												showCancelButton: false,
												closeOnClickModal: false,
												confirmButtonText: '确认',
												cancelButtonText: '取消',
												beforeClose: (action, instance, done) => {
													if (action === 'confirm') {
														let reg = /^[0-9A-Za-z-]{1,30}$/
														if (!reg.test(_sectionNo1)) {
															this.$message.error('标段编号只能输入不超过30位的数字与字母组合！')
															return
														}
														if (_sectionNo2 == _sectionNo1) {
															let data = {
																orderNo: this.tableData[index].orderNo,
																sectionNoAlias: _sectionNo1
															}
															this.requestAPI.addOrderExtraFU(data).then((res) => {
																this.tableData[index].sectionNoAlias = _sectionNo1
																resolve(true);
																done();
															})
														} else {
															this.$message.error('两次输入结果不一致，请确认')
														}

													} else {
														done();
													}

												}
											}).then(action => {});
										} else {
											resolve(true);
										}
									} else if (res.data.status == 2) {
										this.$confirm(
												"检测到您在平台内的基本户信息与交易中心的基本户信息不一致,暂不能进行付款操作,您可变更平台认证或交易中心认证信息后继续完成付款",
												"提示", {
													confirmButtonText: "去变更",
													cancelButtonText: "取消",
													type: "warning",
												}
											)
											.then(() => {
												this.$router.push({
													path: "/internalSystem/certification/basicInfo/info",
													query: {
														edit: 1,
													},
												});
												reject();
											})
											.catch(() => {
												reject();
											});
									} else if (res.data.status == 3) {
                    let channelNeedSelfMsg = ['0028', '0034'];
                    let channel = this.tableData[index].applicantChannel;
                    let statusMsg = channelNeedSelfMsg.indexOf(channel) > -1 ? res.data.statusMsg : '未在交易中心找到该笔订单信息，请删除该笔订单并前往交易中心重新申请';
										this.$confirm(
												statusMsg,
												"提示", {
													confirmButtonText: "确认",
													showCancelButton: false,
													type: "warning",
												}
											)
											.then(() => {
												reject();
											})
									} else if (res.data.status == 4) {
										this.$confirm(res.data.statusMsg,
												"提示", {
													confirmButtonText: "确认",
													showCancelButton: false,
													type: "warning",
												}
											)
											.then(() => {
												reject();
											})
									} else {
										reject();
									}
								});
							} else {
								resolve(true);
							}
						}).then((bools) => {
							successBack(bools)
						});
					}
				});
			},
			payClose() {
				this.showPayment = false
			},
			// 撤销退款
			successShow() {

				if (this.tableData[this.targetIndex].orderStatus == 7) {
					this.tableData.splice(this.targetIndex, 1);
				} else {
					let tem = this.tableData[this.targetIndex]
					tem.orderStatus = 9
					this.$set(this.tableData, this.targetIndex, tem)
				}
				this.showRevokeOrder = false;
				this.orderSingleDetail = "";
			},
			cancelShow() {
				this.showRevokeOrder = false;
				this.orderSingleDetail = "";
			},
			// 勾销流水
			payCallback(num) {
				this.$router.push("/internalSystem/orderManagement/generationLetter");
				for (let i = 0; i < this.tableData.length; i++) {
					if (this.tableData[i].orderNo == num) {
						this.tableData.splice(i, 1);
						return;
					}
				}
			},
			// 选择完担保机构时的回调
			successBack() {
				this.open(this.targetIndex, 'pay', true); // 第三个参数是避免open中某些弹框二次出现
			}
		},
		destroyed() {},
	};
</script>
<style>
	.el-popover {
		white-space: pre-line;
	}

	.el-popover__title {
		color: #de4f4f;
	}
</style>
<style lang="less" scoped>
	@import "../../accountCenter/index.css";

	.ToAudit {
		width: 100%;
		// height: 64px;
		// background: #ffffff;
		// box-shadow: 0 1px 4px 0 rgba(0, 21, 41, 0.12);

		.cToAudit-top {
			width: 100%;
			background: #ffffff;
			box-shadow: 0 1px 4px 0 rgba(0, 21, 41, 0.12);
		}

		.cToAudit {
			position: relative;
			// min-width: 1240px;
			background: white;
			margin: 20px 20px 0px 20px;
			padding: 10px 12px 0px 10px;
			box-sizing: border-box;
            .el-row {
                font-size: 14px;
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                margin-bottom: 15px;
                .el-col {
                    display: flex;
                    align-items: center;
                    margin: 7px 0;
                    &.search-btn{
                        justify-content: flex-end;
                    }
                    span {
                        font-family: PingFangSC-Regular;
                        font-size: 14px;
                        color: rgba(0, 0, 0, 0.85);
                        line-height: 22px;
                        // min-width: fit-content;
                        width: var(--inputLargeLabelWidth);
                        flex-shrink: 0;
                        text-align: right;
                    }
                    .selectClass {
                        /deep/ .el-input {
                            width: 100%;
                        }
                        /deep/ .el-input__inner {
                            height: 40px;
                            line-height: 40px;
                        }
                    }
                    .el-date-editor{
                        width: calc(50% - 140px);
                    }
                }
            }
		}

		.btnClass {
			display: flex;
			justify-content: flex-end;

			.chongzhiBtn {
				background-color: white;
				color: black;
				border: 1px solid #d9d9d9;
				margin-left: 8px;
			}
		}

		.createNew {
			width: fit-content;
			margin-top: 20px;
			padding: 0 16px;
		}

		.innerBottom {
			position: relative;
			// margin-top: 30px;
			font-size: 14px;
			min-height: calc(100vh - 340px);
			// min-height: 400px;
			// padding-bottom: 80px;

			// min-height: 400px;
			// padding-bottom: 60px;
            /deep/ .el-table thead {
                font-size: 14px;
                color: #333333;
                font-weight: normal;
            }	
			.tableBtn {
				cursor: pointer;
				font-size: 13px;
				color: #1890ff;
				text-decoration: none;
				font-size: 13px;
				color: #1890ff;
				width: fit-content;
				margin: auto;
        // display: contents;
        // 置灰
        &.stop-click{
          cursor: not-allowed;
          color: #999;
        }
			}

			.divClass {
				display: flex;
				justify-content: center;
				text-align: center;
			}

			// /deep/ .el-table__row .is-hidden span{
			// 	display: none;
			// }
			// /deep/ .el-table__header .is-hidden span{
			// 	display: none;
			// }
		}

		.pagePart {
			text-align: end;
			padding: 15px 0;
		}

		/deep/ .el-input--suffix .el-input__inner {
			// height: 32px;
			// line-height: 32px;
    }
	}
</style>
